import { render, staticRenderFns } from "./QuizMultipleChoiceMultipleAnswers.vue?vue&type=template&id=4da02f25&"
import script from "./QuizMultipleChoiceMultipleAnswers.vue?vue&type=script&lang=js&"
export * from "./QuizMultipleChoiceMultipleAnswers.vue?vue&type=script&lang=js&"
import style0 from "./QuizMultipleChoiceMultipleAnswers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports